import { gql } from "@apollo/client"

export const GET_TOPUP_PACKAGES = gql`
  query getTopupPriceList($channelSlug: String!, $productSlug: String!) {
    product(channel: $channelSlug, slug: $productSlug) {
      productType {
        name
      }
      id
      name
      defaultVariant {
        name
      }
      variants {
        name
        id
        pricing {
          price {
            gross {
              currency
              amount
            }
          }
        }
      }
    }
  }
`
